import React from 'react';

import { InternalLink } from '../InternalLink';

import * as classes from './style.module.scss';

interface Props {
  image: React.ReactNode;
  title: string;
  url: string;
  'data-testid'?: string;
}

export const GridItem: React.FC<Props> = ({
  title,
  url,
  image,
  'data-testid': dataTestId,
}) => {
  return (
    <InternalLink
      role="listitem"
      to={url}
      className={classes.root}
      data-testid={dataTestId}
    >
      {image}
      <div className={classes.title}>{title}</div>
    </InternalLink>
  );
};
